import React from 'react';
import { Box, Stack, Text } from '@atlaskit/primitives';

export const AchMethodInTable: React.FC<{ bankName: string; last4: string }> = ({ bankName, last4 }) => {
  return (
    <Box testId="ach-method-in-table">
      <Stack space="space.050">
        <Text size="medium">{bankName}</Text>
        <Text size="small" color="color.text.subtlest">
          •• •••• {last4}
        </Text>
      </Stack>
    </Box>
  );
};
